import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errorMessage } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { applySession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      try {
        if (!sessionId) throw new Error("Missing session");
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        applySession(data);
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });  // Home routes by role: super admin → /admin, owner → /dashboard, staff → /scan
      } catch (e) {
        toast.error(errorMessage(e, "Google sign-in failed"));
        window.history.replaceState(null, "", "/login");
        navigate("/login", { replace: true });
      }
    })();
  }, [applySession, navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-slate-950 text-slate-300" data-testid="auth-callback">
      <div className="flex items-center gap-3"><span className="h-3 w-3 rounded-full bg-emerald-400 scan-pulse" /> Signing you in…</div>
    </div>
  );
}
